// extracted by mini-css-extract-plugin
module.exports = {"fullform":"Form_fullform__24w36","form-error":"Form_form-error__1KxSK"};